import "../assets/sidebarKanban.css"
import Button from "../../../common/components/Button.jsx"
import Textfield from "../../../common/components/Textfiled";
import { useRef } from "react";

function SidebarKanban({ onAddTask, onImportTask, onFilterChange }) {
  const refInputFile = useRef(null);

  const handleSelectFile = () => {
    refInputFile.current.click();
  }

  const handleChangeFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    onImportTask(file);
  }


  return (
    <aside className="sidebar-kanban mx-auto">
      <header style={{ display: 'flex', gap: '1rem', flexDirection: 'column' }}>
        <Button onClick={onAddTask}>
          ➕ Agregar
        </Button>
        <Button onClick={handleSelectFile}>
          📥 Importar
        </Button>
        <a href="/plantilla_importar_tareas.csv" download="plantilla_importar_tareas.csv" className="btn btn-outline-secondary btn-sm text-center">
          📄 Descargar plantilla
        </a>
        <input type="file" ref={refInputFile} onChange={handleChangeFile} hidden />
      </header>
      <div className="filters">
        <h2>Filtros</h2>

        <div>
          <label>
            <span>Tipo:</span>
            <select onChange={(e) => onFilterChange({ name: 'type', value: e.target.value })}>
              <option value="">Todos</option>
              <option value="work">Plan anual de trabajo</option>
              <option value="training">Plan anual de capacitación</option>
              <option value="goal">Meta</option>
            </select>
          </label>
        </div>

        <div>
          <Textfield name="startDate" type="date" label="Fecha de inicio" onChange={onFilterChange} />
        </div>

        <div>
          <Textfield name="endDate" type="date" label="Fecha de fin" onChange={onFilterChange} />
        </div>
      </div>
    </aside>
  );
}
export default SidebarKanban;
